import { render, staticRenderFns } from "./Motorista.vue?vue&type=template&id=766ef55e"
import script from "./Motorista.vue?vue&type=script&lang=js"
export * from "./Motorista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports